import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from "@angular/router";
import {ThemeInitializer} from "../common/services/theme.initializer";
import {LicenseGuard} from "./license/license.guard";

const routes: Routes = [{
    path: "licensenotfound",
    loadChildren: () => import("./license/license.module").then(mod => mod.LicenseModule),
  }, {
    path: "patientkiosk",
    loadChildren: () => import("../app-main/patient.kiosk/patient.kiosk.module").then(mod => mod.PatientKioskModule),
    canActivate: [LicenseGuard],
    resolve: {
      initData: ThemeInitializer
	}
  }, {
    path: "",
    loadChildren: () => import("../app-main/app-main.module").then(mod => mod.AppMainModule),
    canActivate: [LicenseGuard]
  },
	// otherwise redirect to home
	{
	  path: "**", redirectTo: ""
	}];

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		RouterModule.forRoot(routes)
	],
	exports: [RouterModule],
	providers: []
})
export class AppRoutingModule { }
